<template>
<div class="container overflow-hidden">
<flash-message class="myCustomClass"></flash-message>
<v-card>
<v-card-title>
<h2>{{ ctitle }}</h2>
<v-spacer></v-spacer>
<v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
        <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >(+{{ filteredheaders.length - 1 }} others)</span>
      </template>
        </v-select>
      </v-flex>

<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-text-field  clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

</v-card-title>   

<v-data-table :footer-props="{'items-per-page-options': [1000,10000]}"  :headers="filteredheaders"
:loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" group-by="created_at_date" group-desc multi-sort>

<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

<template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
          <span> {{ header.text }} </span>
	  <div v-if="headers_to_filter.includes(header.text)">
          <div v-if="filters.hasOwnProperty(header.value)">
								<v-combobox
									flat
									hide-details
									multiple
									attach
									chips
									full-width
									hide-no-data
									clearable
                 						        disable-lookup
									:items="columnValueList(header.value).sort()"
									v-model="filters[header.value]">
                  							<template v-slot:selection="{ item, index }">
                      							<v-chip v-if="index < 5">
											 <span> 
                        									{{ item }} 
                      									 </span>
									</v-chip>
									<span v-if="index === 5" class="grey--text caption" > 
                      							(+{{ filters[header.value].length - 5 }} others) 
                      							</span>
									</template>
								</v-combobox>
							</div>
							</div>
	</template>

<template slot="items" slot-scope="props">
<td class="table-fit" v-for="header in filteredheaders"><span style="font-size: 100%;" v-bind:class="BackgroundColor(props.item, header.value)">{{ props.item[header.value] }}</span></td>
</template>

<template v-slot:item.sis_imports_id_url="{ item }">
          <a :href="'https://uispringfield.instructure.com/api/v1/accounts/1/sis_imports/' + item.sis_imports_id" target="_blank">{{ `${item.sis_imports_id}`  }}</a>
</template>

<v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>

</v-data-table>

</v-card>
        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackcolor">
            {{ snacktext }}
            <v-btn color="white" text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
</div>
</template>

<script>
import XLSX from 'xlsx';

export default {
	data () {
		return {
app_name: process.env.MIX_APP_NAME,
search: '',
fill:[],
headers_to_filter: ['Method', 'Action', 'Sis Course Id'],
filteredheaders: [],
filteredheaderarray: [],
headerarray:[],
loadingUpdate: false,
progress_bar_loading: true,
                snackbar: false,
                snackcolor: '',
                snacktext: '',
editedItem: {
                    id: '',
                    digits: '',
		    method: '',
                    comments: '',
			
},
dialog: false,
		rowsPerPageItems: [10,50,100,2000],
		missing_header: { text: 'Registered for Fall', value: 'has_registered', sortable: true, },
		headers: [
                { text: 'Integration Id', value: 'uin', sortable: true, groupable: true, },
                { text: 'Sis User Id', value: 'sis_user_id', sortable: true, groupable: true, },
                { text: 'Sis Course Id', value: 'lms_course_name', sortable: true, groupable: true, width: 350, },
                { text: 'Method', value: 'method', sortable: true, groupable: true, width: 350, },
                { text: 'Action', value: 'action', sortable: true, groupable: true, width: 350, },
                { text: 'Sis Import Id', value: 'sis_imports_id_url', sortable: true, groupable: true, },
                { text: 'Notes', value: 'notes', sortable: true, groupable: true, },
                { text: 'Date Created', value: 'created_at_date', sortable: true, groupable: true, },
                { text: 'Time Created', value: 'created_at_time', sortable: true, groupable: true, },
		],
		
		filters: {
			uin:[],
			sis_user_id:[],
			lms_course_name:[],
			method:[],
			action:[],
			sis_imports_id:[],
			created_at_date:[],
			created_at_time:[],
		},

		selected:[],
		pagination: {

		},

		Results:[],
	}
	},
	     created () {
		     this.initialize()
	     },
props: {
ctitle: {
             type: String,
                   required: true,
                              },
       },
       computed:{
		filteredResults() {
		return this.Results.filter(d => {
			return Object.keys(this.filters).every(f => {
				return this.filters[f].length < 1 || this.filters[f].includes(d[f])
			})
		})
		}
       },

methods:
       {
		columnValueList(val) {
			//console.log(val)
			return this.Results.map(d => d[val])
		},

	       mounted() {
	       },
	       initialize()
	       {
		       this.fetchApp()
			this.filteredheaders = this.headers;
			//console.log(this.filteredheaders);
	       },
	        close () {
			this.dialog = false
		},
	       async fetchApp(){
		       await axios.get('/' + this.app_name + '/api/v1/lmsenrollmentaudit')
			       .then((response) => {
					       this.Results = (response.data);
					       this.progress_bar_loading = false;
					       })
		       .catch(error => {});

         },
          customFilter(items, search, filter) {
                    search = search.toString().toLowerCase();
                    this.fill = items.filter(i => (
                                            Object.keys(i).some(j => filter(i[j], search))
                                            ))
                            //console.log(this.fill);
                    return this.fill;
            },
        reset()
                     {
                     this.fetchApp();
                     },
    download() {
      var first_record_json;
      var all_headers;
      var first_record_json;
      var first_record_json_keys;
      var all_headers_not;

      var local_delete = [];

      this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));

      //ADDED has_registered because it was a computed value (template v-slot) that would not go in the download
      this.filteredheaderarray.push(this.missing_header.value)

      this.headers.forEach(element => this.headerarray.push(element.value));
      first_record_json = this.Results[0];

      //console.log(first_record_json);
      first_record_json_keys  = Object.keys(first_record_json);
      all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
      // console.log(all_headers_not);
      // local_delete = this.fill;
      local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
      // console.log(this.filter_delete);
      for (var k =0;k<local_delete.length;k++)
      {
        for(var i=0;i<all_headers_not.length;i++)
        {
                var key = all_headers_not[i];
                delete local_delete[k][key];
        }
      }
      // console.log(this.filter_delete[0]);
      var work = XLSX.utils.json_to_sheet(local_delete);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                        var date = new Date();
      XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                        this.filteredheaderarray = [];
      this.headerarray = [];
    },

   BackgroundColor(student, key) {
	console.log('The key is ', key);
    var result = '';

     if(key == 'uin')
	{
		if(student.is_ap_student === true)
		{
      		result = 'badge p-2 font-weight-light badge-success'
		}
       }

    return result;
  }

 }
}
</script>
